// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"cf0fb1c9","977":"7cabae91"}[chunkId] + ".chunk.js";
};